import React from "react";

const sections = [
  {
    title: "Information we collect",
    content: [
      "We collect the information needed to create and serve your Eira account and orders: your",
      "name, email address, phone number, delivery address and order history. We may also store",
      "account preferences, support messages and information you choose to provide in your",
      "profile.",
    ].join(" "),
  },
  {
    title: "How we use your information",
    content: [
      "We use your information to process and deliver purchases, provide customer support,",
      "communicate about your orders, protect against fraud, maintain our services and meet legal",
      "or accounting obligations. We do not use your contact details for unrelated marketing",
      "without",
      "the appropriate choice or permission.",
    ].join(" "),
  },
  {
    title: "How long we retain information",
    content: [
      "We retain account and order information only for as long as needed to provide the service,",
      "resolve disputes, meet tax, accounting and legal requirements, and enforce our agreements.",
      "Retention periods may differ by record type and applicable law.",
    ].join(" "),
  },
  {
    title: "Requesting deletion",
    content: [
      "You can request deletion of your account from Account → Profile → Request Account Deletion.",
      "We will review your request and delete or anonymise information that is no longer required",
      "to be retained. Some order and transaction records may need to be retained where required",
      "by law.",
    ].join(" "),
  },
  {
    title: "Your choices",
    content: [
      "You can review and update key account details from your account settings. For questions",
      "about this policy or your data, contact us using the contact details shown in the site",
      "footer.",
    ].join(" "),
  },
];

export default function PrivacyPolicy() {
  return (
    <article
      className="mx-auto max-w-3xl px-4 py-14 sm:px-8"
      data-testid="privacy-policy-page"
    >
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8C6D46]">
        Eira Products
      </p>
      <h1 className="mt-4 font-serif text-4xl font-semibold text-[#1E2A24] sm:text-5xl">
        Privacy Policy
      </h1>
      <p className="mt-5 text-sm leading-7 text-[#64748B]">
        This policy explains how Eira Products handles personal information when you use our store.
      </p>
      <div className="mt-10 space-y-9">
        {sections.map((section) => (
          <section
            key={section.title}
            data-testid={`privacy-section-${section.title.toLowerCase().replaceAll(" ", "-")}`}
          >
            <h2 className="font-serif text-2xl font-semibold text-[#1E2A24]">
              {section.title}
            </h2>
            <p className="mt-3 text-sm leading-7 text-[#4B5563]">
              {section.content}
            </p>
          </section>
        ))}
      </div>
    </article>
  );
}